var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "cf-node-properties__field" },
    [
      _vm.closeTimeWarning
        ? _c("i", {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip.top",
                value: _vm.$t("CONCURRENCY_SCHEDULE_WARNING_TT"),
                expression: "$t('CONCURRENCY_SCHEDULE_WARNING_TT')",
                modifiers: { top: true }
              }
            ],
            staticClass:
              "cf-node-properties__hours-filter-day-warning fa fa-exclamation-circle",
            attrs: { "aria-hidden": "true" }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("label", [_c("strong", [_vm._v(_vm._s(_vm.day))])]),
      _vm._v(" "),
      _vm.hoursType == "advanced"
        ? _c("nzToggle", {
            on: { onToggle: _vm.updateOpenStatus },
            model: {
              value: _vm.isOpenStatus,
              callback: function($$v) {
                _vm.isOpenStatus = $$v
              },
              expression: "isOpenStatus"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "cf-node-properties__input" }, [
        _c("input", {
          staticClass: "form-control",
          attrs: {
            type: "time",
            step: "300",
            "aria-label": "Open Time",
            disabled: _vm.disabled
          },
          domProps: { value: _vm.openTime },
          on: {
            change: function($event) {
              return _vm.updateOpenTime($event.target.value)
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "cf-node-properties__input" }, [
        _c("input", {
          staticClass: "form-control",
          attrs: {
            type: "time",
            step: "300",
            "aria-label": "Close Time",
            disabled: _vm.disabled
          },
          domProps: { value: _vm.closeTime },
          on: {
            change: function($event) {
              return _vm.updateCloseTime($event.target.value)
            }
          }
        })
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }